export const CATEGORIES = ['常用推荐', '搜索资讯', '影音娱乐', '学习阅读', '工作办公', '设计创作', '开发工具', '生活服务'] as const;
export const PRICING = ['免费', '免费增值', '付费'] as const;
export const ACCESS = ['较稳定', '可能波动', '未验证'] as const;

export type Category = string;
export type Pricing = typeof PRICING[number];
export type AccessStatus = typeof ACCESS[number];
export type ToolStatus = 'pending' | 'published' | 'rejected';

// The API keeps the historical AiTool name so existing D1 rows remain compatible.
export interface AiTool {
  id: string;
  slug: string;
  name: string;
  summary: string;
  description: string;
  url: string;
  category: Category;
  tags: string[];
  pricing: Pricing;
  accessStatus: AccessStatus;
  chinese: boolean;
  loginRequired: boolean;
  featured: boolean;
  rank: number;
  status: ToolStatus;
  bestFor: string;
  capabilities: string[];
  logo: string;
  submitterEmail?: string;
  reviewNote?: string;
  createdAt?: string;
  updatedAt?: string;
}
